import SvgIcon from "../../../../parts/SvgIcon";

/** Icon + title + text + actions block used by every empty / error state. */
const DoorEmpty = ({
  icon = "/img/new-icons/door.svg",
  tone = "default",
  title,
  text,
  actions,
  big = false,
  children,
}) => (
  <div className={`door-empty${big ? " door-empty--big" : ""}`}>
    <span className="door-empty__icon" data-tone={tone}>
      <SvgIcon src={icon} useCurrentColor />
    </span>
    <h3>{title}</h3>
    {text && <p>{text}</p>}
    {actions && <div className="door-empty__actions">{actions}</div>}
    {children}
  </div>
);

export default DoorEmpty;
